/**
 * All possible screen available from the main modal window
 *
 */
export enum TimeTrackingMenuEnum {
    TIME_TRACKING_REPORT = 'report'
}